import store from '@/store';
import { appianPersonalInfoRepository } from '@/forms/api/repository-factory';
import callApi from '@/lib/helpers/call-api';
import { SET_APPIAN_PERSONAL_INFO_RESPONSE } from '@/lib/constants/mutations';
const getPayload = () => {
  const { appId, } = store.state;
  return {
    "app-id": appId,
  };
};

export default {
  async appianPersonalInfo(currentStep, callbacks) {
    const { form } = currentStep;
    let response = false;
    response = await callApi({
      callbacks,
      form,
      formElement: currentStep,
      apiCall: appianPersonalInfoRepository.appianPersonalInfo,
      payload: getPayload(),
    });
    if (response) {
      const appianPersonalInfo = response['status'];
      if (appianPersonalInfo) {
        store.commit(SET_APPIAN_PERSONAL_INFO_RESPONSE, { appianPersonalInfo });
      }
      return response['status'].toUpperCase();
    }
  }
};
